import React from 'react';
import PropTypes from 'prop-types';

const OuterBackground = (props) => {
    const { fillColor, className } = props;
    return (
        <svg className={className} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" style={{ padding: 2 }}>
            <title>icon-fill-colour-outer</title>
            <desc>Created with Sketch.</desc>
            <g id="icon-fill-colour-outer" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Icons-/-Custom-/-Fill-Colour-Outer" transform="translate(-4.000000, -4.000000)">
                    <rect id="icn-bg" fillOpacity="0" fill="#FFFFFF" x="0" y="0" width="32" height="32" />
                    <rect id="fill-right" stroke="#727273" strokeWidth="1.5" fill={fillColor} x="19.75" y="9.75" width="3.5" height="12.5" />
                    <rect id="bar-center" fill="#727273" x="15" y="9" width="2" height="14" />
                    <rect id="fill-left" stroke="#727273" strokeWidth="1.5" fill={fillColor} x="8.75" y="9.75" width="3.5" height="12.5" />
                </g>
            </g>
        </svg>
    );
};

OuterBackground.propTypes = {
    fillColor: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
};

export default OuterBackground;
